// JOBE-0162.5: PersonSlugRouter — type-dispatching router for
// /organization/people/:id.
//
//   - type === 'human'  → render HumanProfilePage
//   - type === 'agent'  → 302 to /agent/:id (W2 surface; one URL per entity)
//   - unknown slug      → "Person not found" empty state with back-link
//
// The agent-slug redirect preserves the URL fragment so any drill-context
// (`#from=…`) survives the hop. react-router's <Navigate> drops the hash
// when `to` is a plain path string, so we splice it on manually.

import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useOrganizationPeople } from './fetchOrganizationPeople.js';
import { HumanProfilePage } from './HumanProfilePage.jsx';

function NotFound({ id }) {
  return (
    <div className="hp-not-found" data-testid="hp-not-found">
      <h1>Person not found</h1>
      <p>
        No directory entry matches <code>{id}</code>.
      </p>
      <p>
        <a href="/organization" data-testid="hp-not-found-back">
          Back to organization
        </a>
      </p>
    </div>
  );
}

export function PersonSlugRouter() {
  const { id } = useParams();
  const { hash } = useLocation();
  const { rows, loading } = useOrganizationPeople();

  if (loading) {
    return (
      <div data-testid="org-profile-loading">Loading…</div>
    );
  }

  const row = rows.find((r) => r.id === id);
  if (!row) return <NotFound id={id} />;
  if (row.type === 'agent') {
    // Preserve drill-context fragment (and any other hash entries) across
    // the redirect — `<Navigate to="/agent/:id" />` would drop the hash.
    const target = hash ? `/agent/${id}${hash}` : `/agent/${id}`;
    return <Navigate to={target} replace />;
  }
  return <HumanProfilePage row={row} allRows={rows} />;
}
